import { Link } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";
import FooterLogo from "../../elements/footer-logo/FooterLogo";
import { MdEmail, MdPhoneInTalk } from "react-icons/md";
import CtaLayoutOne from "../../component/cta/CtaLayoutOne";

const FooterOne = ({ parentClass }) => {
  return (
    <>
      <CtaLayoutOne />
      <footer className={`footer-area ${parentClass}`}>
        <div className="container">
          <div className="footer-main">
            <div className="row">
              <div className="col-xl-5 col-lg-5 border-end">
                <div className="footer-widget1 ">
                  <div className="footer-newsletter">
                    <FooterLogo image="/images/ucwf-logo-footer.png" />
                    <h6 className="title">UCWF Facilites Management LLC</h6>
                    <p className="">
                      UCWF Provides Cost-Effective Facilities Management Service
                      With 24/7 Support, Ensuring Your Building Stays In Top
                      Condition
                    </p>
                    <span style={{ display: "flex", flexDirection: "column" }}>
                      <li className="d-inline-flex phone-item">
                        <MdPhoneInTalk className="icon-right" />
                        <a href="tel:800-8293(800 UCWF)">800 8293 (800 UCWF)</a>
                      </li>
                      <li className="d-inline-flex phone-item">
                        <FaPhoneAlt className="icon-right" size={15} />
                        <a href="tel:+971 44357619">+971 44357619</a>
                      </li>
                      <li className="d-inline-flex">
                        <MdEmail className="icon-right" size={20} />
                        <a href="mailto:info@ucwf.net">info@ucwf.net</a>
                      </li>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-xl-7 col-lg-7 ">
                <div className="row1 d-lg-flex justify-content-lg-evenly">
                  {/*   */}
                  <div className="col-sm-4">
                    <div className="footer-widget">
                      <h6 className="widget-title">
                        <Link to={process.env.PUBLIC_URL + "/who-we-are"}>
                          About us
                        </Link>
                      </h6>
                      <div className="footer-menu-link">
                        <ul className="list-unstyled">
                          <li>
                            <Link to={process.env.PUBLIC_URL + "/who-we-are"}>
                              Who We Are
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={process.env.PUBLIC_URL + "/mission-vision"}
                            >
                              Mission & Vision
                            </Link>
                          </li>
                          <li>
                            <Link to={process.env.PUBLIC_URL + "/testimonials"}>
                              Testimonials
                            </Link>
                          </li>
                          <li>
                            {" "}
                            <Link
                              to={process.env.PUBLIC_URL + "/health-safety"}
                            >
                              Health & Safety
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={process.env.PUBLIC_URL + "/sustainability"}
                            >
                              Sustainability
                            </Link>
                          </li>
                          <li>
                            <Link to={process.env.PUBLIC_URL + "/smart-tech"}>
                              Smart Tech
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="footer-widget">
                      <h6 className="widget-title">
                        <Link to={process.env.PUBLIC_URL + "/services"}>
                          Services
                        </Link>
                      </h6>
                      <div className="footer-menu-link">
                        <ul className="list-unstyled">
                          <li>
                            <Link
                              to={
                                process.env.PUBLIC_URL + "/service/ifm-services"
                              }
                            >
                              IFM Services
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={
                                process.env.PUBLIC_URL +
                                "/service/hard-services"
                              }
                            >
                              Hard Services
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={
                                process.env.PUBLIC_URL +
                                "/service/soft-services"
                              }
                            >
                              Soft Services
                            </Link>
                          </li>
                          <li>
                            {" "}
                            <Link
                              to={
                                process.env.PUBLIC_URL +
                                "/service/security-services"
                              }
                            >
                              Security Services
                            </Link>
                          </li>
                          <li>
                            {" "}
                            <Link
                              to={
                                process.env.PUBLIC_URL +
                                "/service/specialized-services"
                              }
                            >
                              Specialized Services
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 ">
                    <div className="footer-widget ">
                      <h6 className="widget-title">
                        <Link to={process.env.PUBLIC_URL + "/contact-us"}>
                          Contact
                        </Link>
                      </h6>
                      <div className="footer-menu-link">
                        <ul className="list-unstyled">
                          <li>
                            <Link
                              to={
                                process.env.PUBLIC_URL + "/contact-us#contact"
                              }
                            >
                              Contact Us
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={process.env.PUBLIC_URL + "/request-quote"}
                            >
                              Request a Quote
                            </Link>
                          </li>
                          <li>
                            <Link to={process.env.PUBLIC_URL + "/faqs"}>
                              FAQs
                            </Link>
                          </li>
                          <li>
                            {" "}
                            <Link to={process.env.PUBLIC_URL + "/careers"}>
                              Careers
                            </Link>
                          </li>
                          <li>
                            {" "}
                            <Link
                              to={process.env.PUBLIC_URL + "/cookie-policy"}
                            >
                              Cookie Policy
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="row">
              <div className="col-md-6">
                <div className="footer-copyright">
                  <span className="copyright-text" style={{ fontSize: "14px" }}>
                    © {new Date().getFullYear()}. All rights reserved by{" "}
                    <a href="https://axilthemes.com/">UCWF</a>.
                  </span>
                </div>
              </div>
              <div className="col-md-6">
                <div className="footer-bottom-link">
                  <ul className="list-unstyled"></ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterOne;
